module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/area-19030b15bdae85ca11cda6b2d4f837b4.png";